// noinspection JSAnnotator
import Main from '@/views/Main.vue';
import { resolve } from 'tinymce';

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
    path: '/login',
    name: 'login',
    meta: {
        title: 'Login - 登录'
    },
    component: resolve => {
        require(['@/views/login.vue'], resolve);
    }

};


// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
    path: '/',
    name: 'otherRouter',
    redirect: '/index',
    component: Main,
    children: [
        {
            path: 'index',
            title: '任务管理',
            name: 'mission-index',
            component: resolve => {
                require(['../zhaocha/digitalHuman/index.vue'], resolve);
            },
            meta: {
              keepAlive: true
            }
        },
        {
          path: 'createProductImg',
          title: '创建产品图',
          name: 'select-index',
          component: resolve => {
            require(['../zhaocha/digitalHuman/material/product/edit.vue'], resolve);
          }
        },
        {
            path: 'select',
            title: '选择形象',
            name: 'select-index',
            component: resolve => {
                require(['../zhaocha/digitalHuman/select/index.vue'], resolve);
            }
        },
        {
            path: 'edit',
            title: '编辑作品',
            name: 'edit-index',
            component: resolve => {
                require(['../zhaocha/digitalHuman/edit/index.vue'], resolve);
            }
        },
        {
          path: 'templateEdit',
          title: '编辑作品',
          name: 'template-edit',
          component: resolve => {
            require(['../zhaocha/digitalHuman/digitalBroadcasting/templateEdit.vue'], resolve);
          }
        },
        {
          path: 'templateEdit3',
          title: '编辑作品3',
          name: 'template-edit3',
          component: resolve => {
            require(['../zhaocha/digitalHuman/digitalBroadcasting/templateEditV3.vue'], resolve);
          }
        },
        {
          path: 'templateEdit4',
          title: '编辑作品4',
          name: 'template-edit4',
          component: resolve => {
            require(['../zhaocha/digitalHuman/digitalBroadcasting/templateEditV4.vue'], resolve);
          }
        },
        {
            path: 'chooseTemplate',
            title: '选择模板',
            name: 'choose-template',
            component: resolve => {
                require(['../zhaocha/digitalHuman/digitalBroadcasting/chooseTemplate.vue'], resolve);
            },
            meta: {
              keepAlive: false
            }
        },
        {
          path: 'mobileEditV2',
          title: '移动端任务编辑',
          name: 'mobile-edit-v2',
          component: resolve => {
            require(['../zhaocha/digitalHuman/mission/mobileEditV2.vue'], resolve);
          },
          meta: {
            keepAlive: false
          }
        },
        {
          path: 'personalManager',
          title: '我的',
          name: 'personal-manager',
          component: resolve => {
            require(['../zhaocha/digitalHuman/personalCenter/mobilePersonalManager.vue'], resolve);
          },
          meta: {
            keepAlive: false
          }
        },
        {
          path: 'account',
          title: '账号中心',
          name: 'account',
          component: resolve => {
            require(['../zhaocha/digitalHuman/personalCenter/account.vue'], resolve);
          },
          meta: {
            keepAlive: false
          }
        },
        {
          path: 'customize',
          title: '定制形象',
          name: 'customize',
          component: resolve => {
            require(['../zhaocha/digitalHuman/customize/index.vue'], resolve);
          },
          meta: {
            keepAlive: false
          }
        },
        {
          path: 'submitSuccess',
          title: '定制形象',
          name: 'submitSuccess',
          component: resolve => {
            require(['../zhaocha/digitalHuman/customize/submitSuccess.vue'], resolve);
          },
          meta: {
            keepAlive: false
          }
        },
        {
          path: 'selectContent',
          title: '选文案',
          name: 'select-content',
          component: resolve => {
            require(['../zhaocha/digitalHuman/content/selectContent.vue'], resolve);
          },
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'editContent',
          title: '润色文案',
          name: 'edit-content',
          component: resolve => {
            require(['../zhaocha/digitalHuman/content/editContent.vue'], resolve);
          },
          meta: {
            keepAlive: false
          }
        },
    ]
};

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
// 如果想保持组件keep-alive，组件名和name字段保持一致
export const appRouter = [
    // {
    //     path: '/psi',
    //     icon: 'android-folder',
    //     name: 'psi',
    //     title: '进销存管理',
    //     role: 'share',
    //     show: true,
    //     component: Main,
    //     children: [{
    //         path: 'index',
    //         title: '进销存管理',
    //         name: 'psi-index',
    //         component: resolve => {
    //             require(['../zhaocha/psi/index.vue'], resolve);
    //         }
    //     }]
    // },
];

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
    loginRouter,
    otherRouter,
    ...appRouter,
];



// WEBPACK FOOTER //
// ./src/digitalHuman/router/router.js